import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

// We'll define this in App.js or a context later to manage auth state globally
// For now, an onLoginSuccess prop can be passed if App.js manages isLoggedIn state
function LoginPage({ onLoginSuccess }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(''); // Clear previous errors

        if (!email || !password) {
            setError('Email and password are required.');
            return;
        }

        try {
            const response = await axios.post('/api/auth/login', {
                email: email,
                password: password
            });

            if (response.data && response.data.token) {
                localStorage.setItem('authToken', response.data.token); // Store the token
                localStorage.setItem('userEmail', response.data.email); // Store user email
                
                // If onLoginSuccess prop is provided (from App.js), call it
                if (onLoginSuccess) {
                    onLoginSuccess(response.data.email); // Pass user email or entire user object
                }
                
                navigate('/home'); // Redirect to home page
            } else {
                setError('Login failed: No token received.');
            }
        } catch (err) {
            if (err.response && err.response.data && err.response.data.message) {
                setError(`Login failed: ${err.response.data.message}`);
            } else if (err.request) {
                setError('Login failed: No response from server. Ensure the backend is running.');
            } else {
                setError(`Login failed: ${err.message}`);
            }
        }
    };

    return (
        <div className="form-container">
            <h2>Login</h2>
            <form onSubmit={handleSubmit}>
                {error && <p style={{ color: 'red' }}>{error}</p>}
                <div>
                    <label htmlFor="email">Email:</label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label htmlFor="password">Password:</label>
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <button type="submit">Login</button>
            </form>
        </div>
    );
}

export default LoginPage; 